import { ComponentProps } from 'react';

import { StyleSheet, View } from 'react-native';
import { Typography } from 'ucl/components/text/Typography';

import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { IFeatureWalmartUiQuery } from 'generated/sanity-graphql';
import { primitive } from 'styles/constants';

import { WalmartPlusWeekOffer } from './offer';

interface IWalmartWeekOffers
  extends NonNullable<NonNullable<IFeatureWalmartUiQuery['Walmart']>['seasonalPromoConfig']> {
  walmartBadge: ComponentProps<typeof WalmartPlusWeekOffer>['badge'];
}

export const WalmartWeekOffers = ({
  logo,
  badge,
  terms,
  configOffers,
  walmartBadge,
}: IWalmartWeekOffers) => {
  return (
    <View style={styles.container}>
      <View style={styles.headerContainer}>
        <Picture
          image={logo?.locale}
          alt={logo?.locale?.asset?.altText || 'Walmart Week Logo'}
          style={styles.logo}
        />
        <View style={styles.badge}>
          <Typography variant="copyTwo" style={{ lineHeight: 24 }}>
            {badge}
          </Typography>
        </View>
      </View>
      <View style={styles.offers}>
        {configOffers?.map(offer => {
          return (
            offer && (
              <WalmartPlusWeekOffer
                key={offer.loyaltyEngineId}
                title={offer.name?.locale}
                text={offer.description?.locale}
                image={offer.localizedImage?.locale?.app}
                badge={walmartBadge}
                configOffer={offer}
              />
            )
          );
        })}
      </View>
      <View>
        {terms?.locale && (
          <SanityBlockRenderer
            textProps={{ color: primitive.$white, variant: 'copyTwo' }}
            linkProps={{ underline: true, color: primitive.$white }}
            content={terms.locale}
          />
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  badge: {
    borderRadius: 4,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    paddingHorizontal: 4,
  },
  container: {
    backgroundColor: primitive.$blueWalmart,
    borderRadius: 10,
    marginVertical: 16,
    padding: 16,
  },
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  offers: {
    gap: 16,
    marginVertical: 16,
  },
  offer: {
    flexDirection: 'row',
    borderRadius: 10,
    backgroundColor: primitive.$white,
    padding: 16,
  },
  offerImage: {
    width: 96,
    height: 96,
  },
  offerContent: {
    flex: 1,
    justifyContent: 'center',
    marginLeft: 16,
  },
  logo: {
    width: 92,
    height: 40,
  },
});
